<template>
  <v-toolbar
    v-if="Articulo.length != 0"
    color="accent"
    dark
    class="fixed-bar"
    height="30"
    elevation="1"
  >
    <v-breadcrumbs :class="[{ navxl: $vuetify.breakpoint.xl }]">
      <v-breadcrumbs-item
        :style="web ? 'cursor: pointer' : 'cursor: not-allowed'"
        @click="web ? navRouteSCat(catart) : null"
      >
        <span
          class="d-inline-block text-uppercase text-truncate"
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'max-width: 180px'
              : 'max-width: 300px'
          "
          >{{ web ? cat : `REspuesto` }}
          <v-icon>mdi-chevron-right</v-icon></span
        >
      </v-breadcrumbs-item>

      <v-breadcrumbs-item
        :style="scat != 0 && web ? 'cursor: pointer' : 'cursor: not-allowed'"
        @click="scat != 0 && web ? navRouteCat(scat, catart) : null"
      >
        <span
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'max-width: 180px'
              : 'max-width: 300px'
          "
          class="d-inline-block text-uppercase text-truncate"
          >{{ scatart }}<v-icon>mdi-chevron-right</v-icon></span
        >
      </v-breadcrumbs-item>

      <v-breadcrumbs-item :disabled="disableNav">
        <strong
          class="
            grey--text
            text--lighten-5
            d-inline-block
            text-uppercase text-truncate
          "
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'max-width: 100px'
              : 'max-width: 320px'
          "
          >{{ Articulo[0].Nombre }}</strong
        >
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </v-toolbar>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import otroArt from "../components/otrosArt";

export default {
  data() {
    return {
      tempdata: [],
      controller: new AbortController(),
    };
  },
  components: {
    otroArt,
  },
  computed: {
    ...mapState(["Articulo", "filter", "idscat", "disableNav"]),

    tam() {
      return this.$vuetify.breakpoint.xlOnly ? 5 : 9;
    },
  },

  methods: {
    ...mapActions(["consolidadoSCategoria"]),
    ...mapMutations([
      "CLR_BUSCARSCAT",
      "GET_BUSCARCAT",
      "GET_BUSCAREPUESTO",
      "CLR_BUSCAREPUESTO",
      "set_checkRepuestoF",
      "CLR_BUSCARPROMO",
      "set_idscatT",
      "CLR_DATOS_SUBCATB",
      "set_AdPromoF",
      "set_tipoB",
      "CLR_BUSCARMARCA",
      "CLR_PROMO",
      "CLR_PROMO",
      "GET_BUSCARSCAT",
      "set_varCategorias",

      "set_changeSubcat",
    ]),
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    goHome() {
      return this.$router.push("../");
    },
    navRouteSCat(codart) {
      this.CLR_BUSCARSCAT();
      //`/subcategoria/${this.$route.params.div}/${this.$route.params.dep}/${id}`

      this.set_varCategorias([10, this.catart, codart]);
      // this.consolidadoSCategoria();
      ///subcategoria/10/15/15 baños
      ///subcategoria/10/10/10 ceramicos
      return this.$router.push(`/subcategoria/10/${this.catart}/` + codart);
    },
    navRouteCat(scat, cat) {
      //actualizo la variable subcategoria
      this.CLR_DATOS_SUBCATB();
      this.set_AdPromoF();
      this.set_tipoB(false);

      this.CLR_BUSCARSCAT();
      this.CLR_BUSCARMARCA();
      this.CLR_PROMO();
      this.set_changeSubcat();
      this.GET_BUSCARSCAT(scat);

      window.scrollTo(0, 0);

      window.localStorage.setItem("subcat", JSON.stringify(scat));
      this.set_varCategorias([10, this.catart, cat]);
      // this.consolidadoSCategoria({signal: this.controller.signal,});
      this.$router.push(`/catalogo/10/${this.catart}/${cat}/${scat}`);
    },
  },
  destroyed() {
    this.controller.abort();
  },
  props: {
    codart: String,
    catart: String,
    scatart: String,
    cat: String,
    scat: Number,
    web: Boolean,
  },
};
</script>
<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 92px;
  z-index: 2;
}
.nolink {
  text-decoration: none;
  color: inherit;
}
.navxl {
  padding: 0px 250px;
}
</style>
